"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Status", {
  enumerable: true,
  get: function () {
    return _types.Status;
  }
});
Object.defineProperty(exports, "useActions", {
  enumerable: true,
  get: function () {
    return _useActions.useActions;
  }
});
exports.useViewAction = exports.useDispatch = exports.useState = exports.ViewActionProvider = exports.initialState = void 0;

var React = _interopRequireWildcard(require("react"));

var _blocks = require("@bueno/blocks");

var _types = require("./types");

var _reducer = require("./reducer");

var _useActions = require("./useActions");

// Context
const initialState = {
  isOpen: false,
  actionStatus: _types.Status.idle,
  addMessageStatus: _types.Status.idle,
  messageStatus: _types.Status.idle,
  mentionsStatus: _types.Status.idle,
  mentionsList: [],
  userDisplayName: undefined,
  action: undefined,
  actionId: undefined,
  messages: undefined,
  error: undefined
};
exports.initialState = initialState;
const stateContext = /*#__PURE__*/React.createContext(undefined);
const dispatchContext = /*#__PURE__*/React.createContext(undefined);
const ViewActionProvider = (0, _blocks.createProvider)(stateContext, dispatchContext, _reducer.reducer, initialState);
exports.ViewActionProvider = ViewActionProvider;
const useState = (0, _blocks.createStateHook)(stateContext);
exports.useState = useState;
const useDispatch = (0, _blocks.createDispatchHook)(dispatchContext);
exports.useDispatch = useDispatch;
const useViewAction = (0, _blocks.createContextHook)(stateContext, dispatchContext);
exports.useViewAction = useViewAction;